<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" v-loading="loading" :visible.sync="visible" :before-close="dialogClose" width="450px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                    <el-form-item   prop="title" label="商品标题">
                        <el-input v-model="form.title" maxlength="80" style="width:300px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="twoTitle" label="商品简介">
                        <el-input v-model="form.twoTitle" maxlength="80" style="width:300px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="price" label="价格(金币)">
                        <el-input v-model="form.price" maxlength="10" type="number" style="width:150px;"></el-input>
                    </el-form-item>

                    <el-form-item prop="showUserRoster" label="下单后接收者">
                        <el-button @click="getMoreUser()">{{form.noticeUserRosterLabel}}</el-button>
                    </el-form-item>

                    <el-form-item   prop="" label="商品图片">
                        <el-upload 
                            class="avatar-uploader"
                            :action="uploadUrl"
                            :disabled="isUploadImage"
                            :show-file-list="false"
                            :auto-upload="true"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="imageUrl" :src="imageUrl" :style="{transform:'rotateZ('+deg+'deg)'}" style="background-color:#d0d0d0;" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>

                    <el-form-item   prop="commodityLinks" label="电商购买链接">
                        <el-input v-model="form.commodityLinks" maxlength="1000" style="width:300px;"></el-input>
                    </el-form-item>

                    <el-form-item   prop="orderNum" label="排序号">
                        <el-input v-model="form.orderNum" maxlength="2" type="number" style="width:150px;"></el-input>
                    </el-form-item>
                  
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框多人 -->
        <div v-if="userTransferMoreVisible">
            <userTransferMore ref="userTransferMore"></userTransferMore>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import userTransferMore from '../../sys/user/UserTransfer.vue';
    import { Base64 } from 'js-base64';

    export default {
        data(){
            return{
                visible: false,
                loading:false,
                userTransferMoreVisible:false,
                form:{
                    id:"",
                    deptId:"",
                    iconUrl:"",
                    title:"",
                    twoTitle:"",
                    price:"",
                    noticeUserRoster:[],
                    noticeUserRosterLabel:"请选择",
                    commodityLinks:"",
                    orderNum:"",
                },
                rules: {
                    title: [
                        { required: true, message: '请输入商品标题', trigger: 'blur' }
                    ],
                    twoTitle: [
                        { required: true, message: '请输入商品简介', trigger: 'blur' }
                    ],
                    price: [
                        { required: true, message: '请输入价格', trigger: 'blur' }
                    ],
                    commodityLinks: [
                        { required: true, message: '请输入电商购买链接', trigger: 'blur' }
                    ]
                },
                uploadForm:new FormData(),
                imageUrl: "",
                uploadUrl:"",
                deg:0,
                isUploadImage:false
            }
        },
        components: {
            userTransferMore
        },
        created:function () {
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id=data.id;
                this.form.deptId=data.deptId;
                this.imageUrl=data.iconUrl;
                this.form.title=data.title;
                this.form.twoTitle=data.twoTitle;
                this.form.price=data.price;
                if(this.$util.isNotEmpty(data.noticeUsers)){
                    this.form.noticeUserRoster=data.noticeUsers.split(',');
                    this.form.noticeUserRosterLabel=data.noticeUsers.split(',').length+"人";
                }else{
                    this.form.noticeUserRosterLabel="请选择";
                    this.form.noticeUserRoster=[];
                }
                this.form.orderNum=data.orderNum;
                this.form.commodityLinks=data.commodityLinks;
                this.uploadForm=new FormData(); 
                this.uploadUrl=this.nameUploadImageUrl;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        this.loading=true;
                        // 不为空，然后base64加密
                        if(this.form.commodityLinks!=null && this.form.commodityLinks!=''){
                            this.form.commodityLinks=Base64.encode(this.form.commodityLinks);
                        }

                        let url= this.commodityUpdateUrl;
                        let data = {
                            id:this.form.id,
                            deptId:this.form.deptId,
                            iconUrl:this.form.iconUrl,
                            title:this.form.title,
                            twoTitle:this.form.twoTitle,
                            price:this.form.price,
                            noticeUsers:this.form.noticeUserRoster.join(','),
                            commodityLinks:this.form.commodityLinks,
                            orderNum:this.$util.isNotEmpty(this.form.orderNum)?this.form.orderNum:"",
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                            this.loading=false;
                        }, (err) => {
                            console.log(err);
                            this.loading=false;
                        });
                    }
               });
            },
            handleAvatarSuccess(res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                 let isJPG = (file.type == 'image/jpeg' || file.type == 'image/png');
                let isLt2M = file.size / 1024 / 1024 < 8;

                if (!isJPG) {
                    this.$message.error('上传商品图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传商品图片大小不能超过 8MB!');
                }
                if(isJPG && isLt2M){
                    // 上传文件
                    let uploadForm=new FormData();
                    uploadForm.append('file', file);
                    this.$axios.post(this.nameUploadImageUrl, uploadForm).then((res) => {
                        if(res.data.status == 200){
                        //    console.log("临时文件目录："+res.data.data.localFile);
                           this.form.iconUrl=res.data.data.localFile;
                        }else{
                            this.$commonFn.showTip(res.data.message, 3);
                        }
                    }, (err) => {
                        console.log(err)
                        this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3);
                    });
                }else{
                    return false;
                }
            },
            // 旋转
            rotate(){
                this.deg += 90;
                if(this.deg >= 360){
                    this.deg = 0
                }
            },
            getMoreUser(){
                this.userTransferMoreVisible=true;
                this.$nextTick(() => {
                    // 教职
                    this.$refs['userTransferMore'].init(2,this.form.noticeUserRoster,2,this.form.deptId);
                })
            },
            setUser(data,name){ 
                if(data.length == 0){
                    this.form.noticeUserRosterLabel="请选择";
                }else{
                    this.form.noticeUserRosterLabel=data.length+"人";
                }
                this.form.noticeUserRoster=data;
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/shop/wares/Update.vue